import React, { useState } from 'react';
import { TSelected } from '../../types';
import styles from './index.module.css';
import { useLocation } from 'react-router-dom';
type TProps = {
  tabs: TSelected[];
  setSelected: React.Dispatch<React.SetStateAction<number>>;
  selected: number;
};
const SupportTabs = ({ tabs, setSelected, selected }: TProps) => {
  const yellowBackgroundColor = styles.yellowBackground;

  return (
    <div className={[styles.supportTabsDiv, 'sl:!w-[99%]'].join(' ')}>
      {tabs.map((tab, index) => (
        <div
          key={tab}
          className={[
            styles.supportTab,
            'font-poppins text-[11px] !py-[4px] !px-[7px] md:!py-[8px] md:!px-[10px] md:text-sm md:min-w-[200px]',
            index === selected && yellowBackgroundColor,
          ].join(' ')}
          onClick={() => {
            setSelected(index);
          }}
        >
          {tab}
        </div>
      ))}
    </div>
  );
};

export default SupportTabs;
